import { AbstractCommand } from '@egr/wcf/modules/core/cmd/AbstractCommand';
export class AbstractRoomCommand extends AbstractCommand {
    constructor(pRoomManager) {
        super(pRoomManager.app);
        this.mRoomManager = pRoomManager;
    }
}
